export function WebSecurityUd() {
    const courses = [
      { 
        title: "Introduction to HTML Web Development", 
        url: "https://www.udemy.com/course/intro-to-html-web-development/?couponCode=ST7MT110524"
      },
      { 
        title: "HTML and CSS for Beginners - Build a Website & Launch ONLINE", 
        url: "https://www.udemy.com/course/html-and-css-for-beginners-crash-course-learn-fast-easy/?couponCode=ST7MT110524"
      },
      { 
        title: "Learn HTML and CSS in 7 Days | Web Developer Bootcamp", 
        url: "https://www.udemy.com/course/learn-html-and-css-in-7-days-web-developer-bootcamp/?couponCode=ST7MT110524"
      },
      { 
        title: "Learn HTML: Course For Beginners", 
        url: "https://www.udemy.com/course/html-course-for-beginners/?couponCode=ST7MT110524"
      },
      { 
        title: "HTML5: HTML Authoring Certification Course", 
        url: "https://www.udemy.com/course/html5-authoring-certification/?couponCode=ST7MT110524"
      }
    ];
  
    return (
      <>
        <h1>Top 5 Recommended Udemy Courses with Certifications</h1>
        <h4>
          1. Dive Into The Main Concepts <br />
          2. Animation Explanations with Real-World Examples <br />
          3. Important Notes and Clarifications
        </h4>
  
        {courses.map((course, index) => (
          <div key={index} style={{ marginBottom: '20px' }}>
            <p>{index + 1}. {course.title}
              <button 
                style={{ padding: '7px', background: 'black', color: 'white', borderRadius: '8px' }}
                onClick={() => window.open(course.url, "_blank")}
              >
                Click Me
              </button>
            </p>
          </div>
        ))}
      </>
    );
  }
  
  export default WebSecurityUd;
  